import { render, staticRenderFns } from "./pointsDetails.vue?vue&type=template&id=d1534b68&scoped=true"
import script from "./pointsDetails.vue?vue&type=script&lang=js"
export * from "./pointsDetails.vue?vue&type=script&lang=js"
import style0 from "./pointsDetails.vue?vue&type=style&index=0&id=d1534b68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.7.15_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1534b68",
  null
  
)

export default component.exports